<!--
 by:wangyingyu
 2019.9.18
 -->
<template>
    <div class="chat" @click='showexpression=false' :class="{selectchatmsg:issel}">

        <!-- 聊天窗口 -->
        <div :class="{chatdailg:showchatdailg != '1'}">

            <!-- 弹出遮罩 -->
            <div class="mask" @click='closechat'></div>

            <!-- 主体 -->
            <div class="chatbox">
                <div class="title">

                    <!-- 时间选择 -->
                    <div class="timeSelect" v-show="showchatdailg!=2">
                        <el-date-picker v-model="timerange" type="datetimerange" :picker-options="pickerOptions"
                            @change="selecttime" prefix-icon='el-icon-date' range-separator="至" start-placeholder="开始时间"
                            end-placeholder="结束时间" value-format="yyyy-MM-dd HH:mm:ss">
                        </el-date-picker>
                    </div>

                    <!-- 聊天记录 -->
                    <div class="txt" v-show="showchatdailg == 2">查看聊天记录</div>

                    <!-- 关闭按钮 -->
                    <a href="javascript:;" v-show="showchatdailg!=1" @click='showtoast' class="btn_close el-icon-close"></a>

                    <!-- 所属微信 -->
                    <div class="bindwx" v-if="selectfriendids.sysWechatAccount && selTeam.activeindex != 2">
                        来自：
                        <el-avatar shape="square" class="avatar" :size="30" :src="selectfriendids.sysWechatAccount.weChatAvatar"></el-avatar>
                        <div class="bindname" :title="selectfriendids.sysWechatAccount.weChatNiceName">
                            {{selectfriendids.sysWechatAccount.weChatNiceName}}
                        </div>
                    </div>

                </div>

                <!-- 聊天窗口 ||!nowsocketstate-->
                <div class="chatCon" id="chatCon" :class="{'cannosend':cansend=='2'}" :style="'height:'+chatconheight+'px;'">
                    <el-scrollbar style="height: 100%;" ref='scrollbar' v-show="chatdata.wechatMessage.data">

                        <!-- 加载更多 -->
                        <a href="javascript:;" class="btn_moreinfo" @click="getmoreHistoryWechatMessage" v-show="chatdata.wechatMessage.data.length!=0&&ismore!=false">加载更多消息</a>

                        <!-- 搜索时段结果 -->
                        <div class="searchResult" v-show="issearchtime">
                            <p class="time">{{timerange?timerange[0]:''}} 至 {{timerange?timerange[1]:''}}</p>
                            <p v-show="chatdata.wechatMessage.data.length==0"> 该时段内没有聊天记录</p>
                        </div>
                        <!-- 显示更多结果 -->
                        <div class="searchResult" v-show="nomore">
                            <p> 没有更多聊天记录</p>
                        </div>

                        <!-- 聊天记录 -->
                        <div class="chatlist">
                            <ul>
                                <li :class="{chatsend:item.isSend=='true',chatreceive:item.isSend=='false'}" v-for="(item,index) in chatdata.wechatMessage.data"
                                    :key="index">


                                    <p class="chattip" v-if="item.contentType=='5' || item.contentType=='101'">
                                        <span v-if="item.content.indexOf('开启了朋友验证') != -1">
                                            {{chatdata.wechatContactinfo.nickname}}开启了朋友验证，你还不是他（她）朋友。请先发送朋友验证请求，对方验证通过后，才能聊天。
                                            <i @click="addfriendshow(item.id)">发送朋友验证</i>
                                        </span>
                                        <span v-else v-html="item.content"></span>
                                    </p>
                                    <div class="chattip" v-if="item.contentType=='16'">
                                        <div class="red_state"><img src="/static/img/icon_redenvelop.png" alt="">{{ JSON.parse(item.content).Title }}</div>
                                    </div>
                                    <!-- <p class="time" v-if="item.contentType==undefined" v-html="item.content">{{item.createTime}}</p> -->
                                    <!-- &&item.contentType!='101' -->
                                    <div class="chatmsg clearfix" v-if="item.contentType!=undefined&&item.contentType!='5'&&item.contentType!='16'&&item.contentType!='101'">
                                        <!-- 头像 -->
                                        <img @click='showremark(item.isSend)' :src="item.isSend==='false'? chatdata.wechatContactinfo.avatar:chatdata.sysWechatAccount.weChatAvatar" alt="" :onerror="errorImg">

                                        <i @click='selectchat(item)' :class="{active:item.select}"></i>
                                        <!-- 媒体显示 -->
                                        <div class="chattxt chatother"  @contextmenu.prevent="e => sendother(e,item)" v-if="item.contentType=='2'||item.contentType=='3'||item.contentType=='4'||item.contentType=='14'"
                                            :class="{'chataudio':item.contentType =='3'}">
                                            <!-- loading -->
                                            <i class="loading el-icon-loading" v-show="item.sendStatus =='1'"></i>
                                            <!-- 发送失败 -->
                                            <i class="iconfont ic_err" v-show="item.sendStatus == '3'&&item.isSend=='true'">&#xe69f;</i>
                                            <!-- 图片 -->
                                           <div class="imgshowbox" v-if="item.contentType=='2' || item.contentType=='14'">
                                                <div v-if="item.content.indexOf('{') != -1 && item.content.indexOf('}') != -1 && item.content.indexOf('http') != -1">
                                                    <el-image v-if="item.contentType=='2'" @click='getsrcList(JSON.parse(item.content).LinkUrl,item.id,JSON.parse(item.content).LinkUrl)'
                                                        ref="imgview" style="max-width: 120px;max-height: 214px;vertical-align: middle" :src="JSON.parse(item.content).Thumb ? JSON.parse(item.content).Thumb : '/static/img/icon_noimg.png'"
                                                        :preview-src-list="[JSON.parse(item.content).LinkUrl]">
                                                    </el-image>
                                                    <img v-if="item.contentType=='14'" style="max-width: 120px;max-height: 214px;vertical-align: middle" :src="JSON.parse(item.content).Thumb ? JSON.parse(item.content).Thumb : '/static/img/icon_noimg.png'" alt="">
                                                    <!--  -->
                                                    <dloading v-if="item.loading"></dloading>
                                                    <div v-if="!JSON.parse(item.content).LinkUrl && !item.loading &&item.contentType=='2' " class="btn-download" @click="getUrl(item.id)"><img src="/static/img/icon_download.png" alt=""></div>
                                                </div>
                                                <div  v-else class="chattxt">
                                                    <p>[不支持的图片类型，请在手机上查看]</p>
                                                </div>
                                            </div>
                                            <!-- audio -->
                                            <div class="audiobtn" :style="item.content | durationtowidth" v-else-if="item.contentType =='3'"
                                                @click="playamr(JSON.parse(item.content).LinkUrl,item.id)">
                                                <audio :id="'audio'+item.id" :src="'http://'+JSON.parse(item.content).LinkUrl"></audio>
                                                <div class="wifi-symbol" :class="{playaudio:audioid == item.id}">
                                                    <div class="wifi-circle first"></div>
                                                    <div class="wifi-circle second"></div>
                                                    <div class="wifi-circle third"></div>
                                                </div>
                                                <em>{{ item.content | audioduration }}</em>
                                                <div class="audio_dot" v-if="!JSON.parse(item.content).LinkUrl"></div>
                                                <div class="audio_loading el-icon-loading" v-show="item.loading"></div>
                                            </div>
                                            <!-- 视频 -->
                                            <div class="videobox" v-else-if="item.contentType =='4'">
                                                <video :id="'video'+item.id" :src="JSON.parse(item.content).LinkUrl"
                                                    controls v-show="videoid == item.id"></video>
                                                <div class="videocover" v-show="videoid != item.id">
                                                    <img :src="JSON.parse(item.content).Thumb ? JSON.parse(item.content).Thumb : '/static/img/icon_novideo.png'" alt="">
                                                    <a v-if="JSON.parse(item.content).LinkUrl" @click="playvideo(JSON.parse(item.content).LinkUrl,item.id)"
                                                        href="javascript:;"></a>
                                                    <div v-if="!JSON.parse(item.content).LinkUrl && !item.loading" class="btn-download" @click="getUrl(item.id)"><img src="/static/img/icon_download.png" alt=""></div>
                                                </div>
                                                <dloading v-if="item.loading"></dloading>
                                            </div>

                                        </div>

                                        <!-- 文字 -->
                                        <div  @contextmenu.prevent="e => sendother(e,item)" class="chattxt" v-else-if="item.contentType=='1'">
                                            <!-- loading -->
                                            <i class="loading  el-icon-loading" v-show="item.sendStatus =='1'&&item.isSend=='true'"></i>
                                            <!-- 发送失败 -->
                                            <i class="iconfont ic_err" v-show="item.sendStatus == '3'&&item.isSend=='true'">&#xe69f;</i>
                                            <!-- 文字 -->
                                            <p v-html="$options.filters.realcontent(item.content)"></p>
                                        </div>

                                        <!-- 链接 -->
                                        <div  @contextmenu.prevent="e => sendother(e,item)" class="chattxt chatlink" v-else-if="item.contentType=='18'">
                                            <i class="loading el-icon-loading" v-show="item.sendStatus =='1'&&item.isSend=='true'"></i>
                                            <i class="iconfont ic_err" v-show="item.sendStatus == '3'&&item.isSend=='true'">&#xe69f;</i>
                                            <a :href="JSON.parse(item.content).linkUrl" target="_blank">
                                                <p class="linktitle">{{JSON.parse(item.content).title}}</p>
                                                <div class="clearfix">
                                                    <p class="linkdes fl">{{JSON.parse(item.content).des}}</p>
                                                    <img class="linkimg fr" :src="JSON.parse(item.content).coverUrl" />
                                                </div>
                                            </a>

                                        </div>

                                        <!-- 扩展链接 -->
                                        <!-- <div class="chattxt" v-else-if="item.contentType=='6'"> -->
                                            <!-- <i class="loading" v-loading="true" v-show="item.sendStatus =='1'&&item.isSend=='true'"></i>
                                            <i class="iconfont ic_err" v-show="item.sendStatus == '3'&&item.isSend=='true'">&#xe69f;</i>
                                            <a :href="JSON.parse(item.content)" target="_blank">{{JSON.parse(item.content)}}</a> -->
                                            <!-- <p>[不支持的消息类型，请在手机上查看]</p> -->
                                        <!-- </div> -->

                                        <!-- 文件 -->
                                        <div  @contextmenu.prevent="e => sendother(e,item)" class="chattxt chatlink" v-else-if="item.contentType=='8'" :class="{'nop':JSON.parse(item.content).Des.split(',')[1] == ' mp3'}">
                                            <!-- loading -->
                                            <i class="loading el-icon-loading" v-show="item.sendStatus =='1'&&item.isSend=='true'"></i>
                                            <!-- 发送失败 -->
                                            <i class="iconfont ic_err" v-show="item.sendStatus == '3'&&item.isSend=='true'">&#xe69f;</i>
                                            <!-- 文字 -->
                                            <audiopaly v-if="JSON.parse(item.content).Des.split(',')[1] == ' mp3'" :mp3url="JSON.parse(item.content).Url"></audiopaly>

                                            <div v-else class="chatfile">
                                                <a :href="JSON.parse(item.content).Url ? JSON.parse(item.content).Url : 'javascript:;'">
                                                    <b class="iconfont chatfile_xls" v-if="JSON.parse(item.content).Des.split(',')[1] == ' xls' || JSON.parse(item.content).Des.split(',')[1] == ' xlsx'">&#xe732;</b>
                                                    <b class="iconfont chatfile_ppt" v-else-if="JSON.parse(item.content).Des.split(',')[1] == ' ppt' || JSON.parse(item.content).Des.split(',')[1] == ' pptx'">&#xe731;</b>
                                                    <b class="iconfont chatfile_doc" v-else-if="JSON.parse(item.content).Des.split(',')[1] == ' doc' || JSON.parse(item.content).Des.split(',')[1] == ' docx'">&#xe737;</b>
                                                    <b class="iconfont chatfile_pdf" v-else-if="JSON.parse(item.content).Des.split(',')[1] == ' pdf'">&#xe732;</b>
                                                    <!-- <b class="iconfont" v-else>{{ JSON.parse(item.content).Des.split(',')[1] }}</b> -->
                                                    <p>{{JSON.parse(item.content).Title}}</p>
                                                    <span>{{JSON.parse(item.content).Des.split(',')[0]}}</span>
                                                </a>
                                            </div>
                                            <a href="javascript:;" v-if="!JSON.parse(item.content).Url && !item.loading" @click="getUrl(item.id)" class="btn_dfile"></a>
                                            <div class="audio_loading el-icon-loading" v-show="item.loading"></div>
                                        </div>

                                        <!-- 名片 -->
                                        <div @contextmenu.prevent="e => sendother(e,item)" class="chattxt" v-else-if="item.contentType=='9'">
                                            <i class="loading el-icon-loading" v-show="item.sendStatus =='1'&&item.isSend=='true'"></i>
                                            <i class="iconfont ic_err" v-show="item.sendStatus == '3'&&item.isSend=='true'">&#xe69f;</i>
                                            <p>[对方发来名片，请在手机上查看]</p>
                                        </div>

                                        <!-- 位置 -->
                                        <div @contextmenu.prevent="e => sendother(e,item)" class="chattxt" v-else-if="item.contentType=='10'">
                                            <i class="loading" v-show="item.sendStatus =='1'&&item.isSend=='true'"></i>
                                            <i class="iconfont ic_err" v-show="item.sendStatus == '3'&&item.isSend=='true'">&#xe69f;</i>
                                            <p>[对方发来位置，请在手机上查看]</p>
                                        </div>

                                        <!-- 红包 -->
                                        <div class="chatred_box" v-else-if="item.contentType=='11'">
                                            <div class="chatred_con"  @contextmenu.prevent="e => sendother(e,item.id)" @click="openred(item,item.isSend)" :class="{ active: JSON.parse(item.content).receiveStatus!= '1' }">
                                                <div class="chatred">
                                                    <div class="tit">{{ JSON.parse(item.content).Title }}</div>
                                                    <div class="state">{{ hbstate[JSON.parse(item.content).receiveStatus] }}</div>
                                                </div>
                                            </div>
                                            <!-- <div class="red_state"><img src="/static/img/icon_redenvelop.png" alt="">你领取了客户经理1的<span>红包</span></div> -->
                                        </div>

                                        <!-- 转账 -->
                                        <div @contextmenu.prevent="e => sendother(e,item.id)" class="chattxt" v-else-if="item.contentType=='12'">
                                            <i class="loading el-icon-loading" v-show="item.sendStatus =='1'&&item.isSend=='true'"></i>
                                            <i class="iconfont ic_err" v-show="item.sendStatus == '3'&&item.isSend=='true'">&#xe69f;</i>
                                            <p>[转账消息，请在手机上查看]</p>
                                        </div>

                                        <!-- 小程序 -->
                                        <div @contextmenu.prevent="e => sendother(e,item)" class="chattxt" v-else-if="item.contentType=='13'">
                                            <i class="loading el-icon-loading" v-show="item.sendStatus =='1'&&item.isSend=='true'"></i>
                                            <i class="iconfont ic_err" v-show="item.sendStatus == '3'&&item.isSend=='true'">&#xe69f;</i>
                                            <p>[收到小程序，请在手机上查看]</p>
                                        </div>

                                        <!-- 语音聊天 -->
                                        <div @contextmenu.prevent="e => sendother(e,item)" class="chattxt" v-else-if="item.contentType=='19'">
                                            <p>{{ item.content }} <span class="chat_yp"></span></p>
                                        </div>
                                        <!-- 视频聊天 -->
                                        <div @contextmenu.prevent="e => sendother(e,item)" class="chattxt" v-else-if="item.contentType=='20'">
                                            <p>{{item.content}}<span class="chat_sp"></span></p>
                                        </div>


                                        <!-- 不支持的消息类型 -->
                                        <div  @contextmenu.prevent="e => sendother(e,item)" class="chattxt" v-else>
                                            <!-- 发送失败 -->
                                            <i class="iconfont ic_err" v-show="item.sendStatus == '3'&&item.isSend=='true'">&#xe69f;</i>
                                            <!-- 文字 -->
                                            <p>[不支持的消息类型，请在手机上查看]</p>
                                        </div>

                                        <div class="clearfix chatbot">
                                            <span class="name" v-if="item.isSend=='false'">{{chatdata.wechatContactinfo.remark?chatdata.wechatContactinfo.remark+'-'+chatdata.wechatContactinfo.nickname:chatdata.wechatContactinfo.nickname}}</span>
                                            <span class="name" v-if="item.isSend=='true'">{{selectfriendids.sysWechatAccount.weChatNiceName}}</span>
                                            <span class="time">{{item.createTime}}</span>
                                        </div>
                                    </div>
                                </li>

                            </ul>
                        </div>
                    </el-scrollbar>
                </div>

                <!-- 发送聊天记录按钮 -->
                <div class="btn_box" v-if="showchatdailg == 3">
                    <a href="javascript:;" @click='closechat' class="btn_cancel">取消</a>
                    <a href="javascript:;" @click='sendchathistorymsg' class="btn_sendchat">确定</a>
                </div>

            </div>
            <!-- 跟单按钮 -->
            <a href="javascript:;" v-show="showchatdailg==1&&getdocumentarybutton" class="btn_documentary iconfont"
                @click='documentarystate'>{{getdocumentary?'&#xe69d;':'&#xe6a3;'}}</a>
        </div>
        <!-- 输入框 -->
        <inputBox
            v-show="showchatdailg == 1&&cansend==1&&wxim=='wx_im_chat'"
            @changefun="changefun"
        ></inputBox>

        <div class="sendbtnbox" :style="'height:' +sendboxh + 'px'">
            <div class="zfbox">
                <img @click="showselfirend" src="/static/img/icon_zf.png" alt="">
                <p>逐条转发</p>
            </div>
            <img @click="closesendchat" src="/static/img/close2.png" alt="">
        </div>

        <!-- 点击头像修改昵称 -->
        <el-dialog class="remarkbox" :usermsg="usermsg" :visible.sync="remarkVisible" top="30vh" width="326px">
            <div class="remarktop">
                <img @click="closeremrk" src="/static/img/close2.png" alt="">
                <div class="imgbox"><img :src="usermsg.avatar" alt="" :onerror="errorImg"></div>
                <div>
                    <div class="name">{{usermsg.nickname}}</div>
                </div>
            </div>
            <div class="remarkbot">
                <span>备注</span>
                <div class="editnickname">
                    <span v-show="!showeditremark">{{oldremark}}</span> <i @click='editremark' v-show="!showeditremark"
                        class="choose"></i>
                    <input ref='nickinput' name='nick' type="text" maxlength="16" v-model="oldremark" v-show="showeditremark" />
                    <a href="javascript:;" v-show="showeditremark" @click="saveremark">确定</a>
                </div>
            </div>
            <div class="remarkbot tipsbot">
                <span>地区</span>
                <div class="editnickname">
                    <span>{{usermsg.country}} {{usermsg.province}} {{usermsg.city}}</span>
                </div>
            </div>
            <div class="remarkbot tipsbot">
                <span>微信号</span>
                <div class="editnickname">
                    <span>{{usermsg.friendWechatno?usermsg.friendWechatno:usermsg.friendid}}</span>
                </div>
            </div>
            <div class="remarkbot tipsbot">
                <span>状态</span>
                <div class="editnickname">
                    <span>{{usermsg.outsideTransactionStatus==1? '已签约':'未签约'}}</span>
                </div>
            </div>
            <div class="remarkbot tipsbot">
                <span>标签</span>
                <div class="editnickname">
                    <span v-if="showtips">{{oldtips.str}}</span> <i v-if="showtips" @click='gettips' class="choose"></i>
                    <div v-if="!showtips" class="edittipsbox">
                        <el-scrollbar style="height: 100%;">
                            <ul class="clearfix">
                                <li v-for="(item,index) in tiplist" :key="index" :class="{'active':item.act==1}" @click="seltip(item.id)">{{item.name}}</li>
                            </ul>
                        </el-scrollbar>
                    </div>
                </div>
            </div>
            <div class="remarkbot tipsbot">
                <span>好友来源</span>
                <div class="editnickname">
                    <span>{{usermsg.addWaySource}}</span>
                </div>
            </div>
            <span slot="footer" class="dialog-footer" v-if="!showtips">
                <el-button @click="showtips = true">取 消</el-button>
                <el-button type="primary" @click="savetip">确 定</el-button>
            </span>
        </el-dialog>


        <div class="addfriend_box" v-show="showaddfriend">
            <!-- <div class="mask"></div> -->
            <div class="addfriend_con" :style="addleft" v-show="showaddfriendcon">
                <div class="tit">
                    添加朋友
                    <a href="javascript:;" @click="showaddfriend=false" class="el-icon-close"></a>
                </div>
                <textarea v-model="addMessage" name="" id="" cols="30" rows="10"></textarea>
                <div class="tip">
                    你需要发送验证请求，对方通过后你才能添加其为朋友。
                </div>
                <div class="btn_box clearfix">
                    <a href="javascript:;" @click="addWxFriends" class="btn_ok">确定</a>
                    <a href="javascript:;" @click="showaddfriend=false">取消</a>
                </div>
            </div>

            <!-- <div class="addfriend_toast" :style="addleft" v-show="!showaddfriendcon">

            </div> -->
        </div>
        <!-- 转发 -->
        <div v-show="sendVisible">
            <ul id="sendtools" class="sendtools">
                <li class="send_item" @click="sendchat()">转发本条</li>
                <li class="send_item" @click="sendchat(true)">转发多条</li>
            </ul>
        </div>
        <!-- 红包 -->
        <redEnvelope v-if="redEnvelopeVisible" :tx="selectfriendids.wechatContactinfo.avatar" :name="selectfriendids.wechatContactinfo.nickname" :redEnvelopeVisible="redEnvelopeVisible" :redEnvelopeData="reddata" @closered="closered"></redEnvelope>
        <!-- 新loading -->
        <div class="newloading" v-show="showloading">
            <div class="mask"></div>
            <div class="con">
                <p>正在进行敏感词校验...</p>
                <div class="loadingimg">
                    <img src="/static/img/icon_loading.png" alt="">
                </div>
            </div>
        </div>

        <!-- selfriend -->
        <selfriend v-if="showself" :show="showself" :contentIdList="contentIdList" @closeselfriend="closeselfriend"></selfriend>
    </div>
</template>

<script>

    import {
        editWechatContactinfoRemark,
        checkWeChatMsg,
        findHistoryWechatMessage,
        pcAddWxFriends,
        friendInfo,
        getFriendTag,
        editFriendTag,
        friendVerification,
        chatcheckSensitiveWord,
        messageSensitiveCheck
    } from '@/utils/api-im.js'
    import {
        mapGetters,
        mapMutations
    } from 'vuex'

    import audiopaly from '@/components/mp3Play'
    import redEnvelope from './redEnvelope'
    import dloading from './loading.vue'
    import inputBox from './InputBox'
    import selfriend from './selfriend'
    export default {
        name: 'chat',
        data() {
            return {
                hbstate: ['','未领取','已领取','已过期'], //红包状态
                pickerOptions: { //时间组件参数
                    shortcuts: [{
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                },
                timerange: '', //时间范围

                remarkVisible: false, //是否弹出修改备注弹窗
                usermsg: {},
                oldremark: '', //备注
                showeditremark: false, //是否显示编辑昵称
                chatmsg: {
                    startindex: -1,
                    endindex: -1,
                    lists: []
                }, //选中的聊天记录
                ismore: true, //是否显示更多聊天记录按钮
                issearchtime: false, //是否是搜索聊天记录
                wxSendTime: '', //查询记录最后一条消息时间戳
                audioid: 0, //播放的音频id
                videoid: 0, //播放的视频id
                msgscrolltop: 0, //记录聊天记录位置
                nomore: false,
                errorImg: "this.src='/static/img/defaluttx.png'",
                srcList: [],
                showaddfriend: false, //添加好友弹窗
                showaddfriendcon: true, //添加好友弹窗内容
                addMessage: '',
                selbtn: 0, //选择时间 默认 0
                addleft: 'left:50%', //添加好友定位
                upload_params: {
                    host: ''
                },
                msgId: '', //添加好友消息id
                chatconheight: '',
                oldtips: {
                    str:'',
                    arr:[]
                },
                showtips: true,
                tiplist:[],
                tdata:{},
                wxim:'',
                reddata: {},
                redEnvelopeVisible: false,
                sendVisible: false,
                seldata:{},
                issel: false,
                showloading:false,
                sendboxh:'',//转发窗口高度
                showself:false,
                contentIdList:[]
            }
        },
        components: {
            audiopaly,
            redEnvelope,
            dloading,
            inputBox,
            selfriend
        },
        props: {
            showchatdailg: {
                type: Number,
                default: 1 //聊天弹窗状态 1 默认 2 聊天记录 3 可选聊天记录 4不可选聊天记录
            },
            chatdata: {
                default: () => {
                    return {
                        wechatContactinfo: {
                            friendid: '',
                            wechatid: ''
                        },
                        wechatMessage: {
                            wxSendTime: '',
                            data: []
                        }
                    }
                }
            }
        },
        computed: {
            ...mapGetters('im', [
                'selectfriendids',
                'chatlist',
                'nowsocketstate',
                'newuuid',
                'selTeam',
                'getdocumentary',
                'getdocumentarybutton',
                'cansend',
                'rightbtn'
            ])
        },
        watch: {
            chatdata() {
                this.chatValue = ''
                this.timerange = ''
                this.ismore = true; //是否显示更多聊天记录按钮
                this.nomore = false
                this.issearchtime = false; //是否是搜索聊天记录
                if (this.chatdata.wechatMessage.data.length < 20) {
                    this.ismore = false
                    this.nomore = true
                }
                this.$nextTick(() => {
                    this.resetchatheight()
                    // this.scrollbottom()
                })
            },
            'chatdata.wechatContactinfo.id'(){
                this.issel = false
                this.seldata = {}
            },
            $route() {
                this.$nextTick(() => {
                    this.scrollbottom()
                })
            },
            newuuid() {
                if (!this.issearchtime) {
                    this.$nextTick(() => {
                        this.scrollbottom()
                        console.log('chatdata557')
                    })
                }
            },
            cansend(){
                this.resetchatheight()
            },
            rightbtn(){
                this.sendVisible = false
            }
        },
        mounted() {
            let chatHeight = localStorage.getItem('chatHeight')
            let _this = this;
            this.$nextTick(() => {
                // 重置输入框高度
                window.onresize = () => {
                    this.resetchatheight()
                }
                // 聊天记录拉到最底部
                this.scrollbottom()
                let div = this.$refs['scrollbar'].$refs['wrap'];
                div.addEventListener('scroll', () => {
                    // 滚动条添加监听
                    this.msgscrolltop = div.scrollHeight - div.scrollTop
                    // 滚动条到顶部加载更多
                    if (div.scrollTop < 10) {
                        this.getmoreHistoryWechatMessage()
                    }
                })
                // setTimeout(res=>{
                    // 获取im发起聊天权限
                    this.wxim = sessionStorage.getItem('wx_im')
                    this.resetchatheight()
                // },100)
            })

            //刷新页面恢复跟单
            if (this.selectfriendids.wechatContactinfo.friendid) {
                window.parent.postMessage({
                    type: 'open',
                    outsideCustomerId: this.selectfriendids.wechatContactinfo.outsideCustomerId,
                    friendid: this.selectfriendids.wechatContactinfo.friendid
                }, '*')
            }

            let oldtimerange = sessionStorage.getItem('timerange')
            if (oldtimerange) {
                this.timerange = JSON.parse(oldtimerange)
            }

            this.SETDOC(false)
        },
		beforeDestroy() {
          window.parent.postMessage({
            type: 'toggle',
            state: false
          }, '*');
        },
      methods: {
            ...mapMutations('im', [
                'SELECTFRIEND',
                'SELECTFRIENDINFO',
                'SELECTFRIENDDATA',
                'SELECTCHAT',
                'CHATSTATE',
                'MSGID',
                'SETDOC',
                'CLOSERIGHT'
            ]),
            // 转发
            sendother(MouseEvent,obj) {
                this.seldata = obj
                // 通过id和置顶状态
                this.CLOSERIGHT(Math.random())
                console.log(MouseEvent.clientX,MouseEvent.clientY)
                setTimeout(() => {
                    this.sendVisible = true  // 显示模态窗口，跳出自定义菜单栏
                }, 50);
                var menu = document.querySelector('#sendtools')
                document.addEventListener('click', this.removeclick) // 给整个document添加监听鼠标事件，点击任何位置执行
                menu.style.display = "block";
                menu.style.left = MouseEvent.clientX + 10 + 'px'
                menu.style.top = MouseEvent.clientY + 'px'
            },
            removeclick() { // 取消鼠标监听事件 菜单栏
                this.sendVisible = false
                document.removeEventListener('click', this.foo) // 关掉监听
            },
            // 关闭转发
            closesendchat(){
                this.issel = false
                this.seldata = {}
                const arr = {...this.chatdata}
                arr.wechatMessage.data.forEach(v => {
                    v.select = false
                })
                this.SELECTFRIEND(arr)
            },

            showselfirend(){
                // 消息组
                const arr = this.chatdata.wechatMessage.data
                let list = []
                let txtarr = []
                arr.forEach(v=>{
                    if(v.select){
                        list.push(v.id)
                        if(v.contentType ==1){
                            console.log(v)
                            txtarr.push(v.content)
                        }
                    }
                })
                console.log(list,txtarr,arr)
                if(list.length > 0){
                    this.contentIdList = list
                    // 打开转发好友组件
                    if(txtarr.length > 0){
                    // 校验敏感词
                        this.checkWord(txtarr).then(res=>{
                            console.log('打开转发好友组件',this.contentIdList)
                            // 打开转发好友组件
                            this.showself = true
                        })
                    }else {
                        // 打开转发好友组件
                        this.showself = true
                    }
                }else{
                    this.$toast('未选消息')
                }


            },

            // 消息是否可转发
            checkmsg(item){
                console.log(item,'checkmsg')
                // 判断是否可以发送
                const obj = item
                let data = {}
                if(obj.contentType == 1){
                    data = {
                        flag:true
                    }
                }else if(obj.contentType == 2 || obj.contentType == 3 || obj.contentType == 4){
                    if(obj.content.indexOf('LinkUrl') != -1){
                        data = {
                            flag:true
                        }
                    }else{
                        data = {
                            flag:false,
                            msg:'未获取原文件，不支持转发'
                        }
                    }
                }else if(obj.contentType == 14){
                    if(obj.content.indexOf('http') != -1){
                        data = {
                            flag:true
                        }
                    }else{
                        data = {
                            flag:false,
                            msg:'不支持转发的消息'
                        }
                    }
                }else if(obj.contentType == 8){
                    if(JSON.parse(obj.content).Url){
                        data = {
                            flag:true
                        }
                    }else{
                        data = {
                            flag:false,
                            msg:'未获取原文件，不支持转发'
                        }
                    }
                }else{
                    data = {
                        flag:false,
                        msg:'不支持的转发类型'
                    }
                }
                return data
            },

            // 转发校验敏感词
            checkWord(txtarr){
                return new Promise((resolve,reject)=>{
                    // 校验敏感词
                    this.showloading =true
                    this.$post(chatcheckSensitiveWord,{
                        contentList:txtarr
                    }).then(res => {
                        this.showloading =false
                        if(res.data.code == 200){
                            if(res.data.data&& res.data.data.length>0){
                                reject()
                                let arr = []
                                for(let i = 0;i<res.data.data.length;i++){
                                    arr.push(res.data.data[i].sensitiveWordsList[0].sensitiveName)
                                }
                                let str = arr.join(',')
                                this.$confirm('发送内容包含敏感词['+str+'],请重新选择内容', '提示', {
                                    confirmButtonText: '确定',
                                    type: ''
                                }).then(() => {})

                            }else{
                                // 打开选择好友组件
                                resolve()
                            }
                        }else{
                            this.$toast(res.data.msg)
                            reject()
                        }
                    }).catch(err => {
                        this.$toast(err)
                        this.showloading =false
                        reject()
                    })
                })
            },

            sendchat(bool){
                console.log('9',this.seldata)
                if(bool){
                    this.issel = true
                    this.sendboxh = localStorage.getItem('chatHeight')
                }else{
                    this.issel = false
                    const checkdata = this.checkmsg(this.seldata)
                    if(checkdata.flag){
                        // 打开转发好友组件
                        if(this.seldata.contentType ==1){
                            this.checkWord([this.seldata.content]).then(res=>{
                                console.log(res)
                                // 打开转发好友组件
                                this.showself = true
                                this.contentIdList = [this.seldata.id]
                            })
                        }else{
                            // 打开转发好友组件
                            this.showself = true
                            this.contentIdList = [this.seldata.id]
                        }

                    }else{
                        this.$toast(checkdata.msg)
                    }
                }
            },
            closeselfriend(){
                this.showself = false
            },
            // 编辑标签
            edittips() {
                this.showtips = false
            },
            // 打开红包
            openred(data,issend){
                if(issend === 'true'){
                    return false
                }
                this.reddata = data
                this.redEnvelopeVisible = true
            },
            // 输入框回调事件
            changefun(data){
                //输入框高度变化
                if(data.type === 'changeheight'){
                    this.chatconheight = data.data
                }
                //发消息指定当前好友
                if(data.type === 'changetop'){
                    this.addnewchat(data.data.friendid)
                }
            },
            // 关闭红包
            closered(){
                this.redEnvelopeVisible = false

            },

            getUrl(id){
                const list = {...this.chatdata}
                list.wechatMessage.data.forEach(v => {
                    if(v.id === id){
                        v.loading = true
                    }
                })
                console.log(list,'loading')
                this.SELECTFRIEND(list)
                this.socketApi.sendSock({
                    msgType:  'GET_WECHAT_RECORD_DETAILS_REQ',
                    msgContent:  {
                        msgId:  id,
                        weChatId:this.selectfriendids.wechatContactinfo.wechatid
                    }
                })
            },
            // 设置聊天输入框
            resetchatheight() {
                let wh = document.body.clientHeight
                //&& this.nowsocketstate
                const IFRAME_LOAD = !!sessionStorage.getItem('IFRAME_LOAD') || (sessionStorage.getItem('hideheader') === 'true')
                if (this.showchatdailg == 1 && this.cansend == 1  && this.wxim =='wx_im_chat') {
                    let chatHeight = localStorage.getItem('chatHeight')
                    if (chatHeight) {
                        this.getlistheight = chatHeight
                        this.chatconheight = IFRAME_LOAD ? wh - 50 - this.getlistheight : wh - 100 - this.getlistheight
                    } else {
                        this.getlistheight = ''
                        this.chatconheight = IFRAME_LOAD ? wh - 230 : wh - 290
                    }
                } else {
                    this.getlistheight = ''
                    this.chatconheight = IFRAME_LOAD ? wh - 50 : wh - 110

                }
            },

            // 发送文件
            sendfile(e) {
                let file = e.target.files[0];
                //校验
                uploadfile.upload(file).then(data => {
                    //获取oss
                    uploadfile.getossbase(data.file,true).then(osdata => {
                        //上传
                        uploadfile.uploadform(osdata).then(updata => {
                            //成功回调
                            this.uploadSuccess(updata, osdata.fileidlist)
                        })
                    })
                })
            },
            // 上传回调
            uploadSuccess(data, fileidlist) {
                let {
                    file,
                    uuid
                } = data
                let contenttype = null
                let filecon = {}
                let filesize =file.size
                if(filesize>1024){
                    filesize=filesize/1024
                    filesize = filesize.toFixed(1) + 'kb'
                }else if(filesize/1024>1024){
                    filesize = filesize/1024/1024
                    filesize = filesize.toFixed(1) + 'mb'
                }else{
                    filesize = filesize+'b'
                }
                // {"linkUrl":"","coverUrl":"","source":"微信电脑版","title":"www.docx","type":"6","typeStr":"[文件]","fileSize":"10.7KB","fileSuffix":"docx","des":"10.7KB, docx"}
                if (file.type === 'image/jpeg' || file.type === 'image/png') {
                    contenttype = 2
                    filecon = {
                        Thumb: fileidlist[uuid].host + fileidlist[uuid].filename
                    }
                    filecon.LinkUrl = fileidlist[uuid].host + fileidlist[uuid].filename
                }else if (file.type === 'audio/mp3') {
                    contenttype = 8
                    filecon = {
                        Title: file.name,
                        Type:6,
                        TypeStr:"[文件]",
                        Des:filesize+', mp3',
                        Thumb: fileidlist[uuid].host + fileidlist[uuid].filename
                    }
                    filecon.Url = fileidlist[uuid].host + fileidlist[uuid].filename
                }else if (file.type === 'video/mp4') {
                    contenttype = 4
                    filecon = {
                        Thumb: fileidlist[uuid].host + fileidlist[uuid].filename +
                            "?x-oss-process=video/snapshot,t_0,m_fast",
                    }
                    filecon.LinkUrl = fileidlist[uuid].host + fileidlist[uuid].filename
                }else{
                    contenttype = 8
                    let fileSuffix = fileidlist[uuid].type.replace('.','')
                    filecon = {
                        Title: file.name,
                        Type:6,
                        TypeStr:"[文件]",
                        Des:filesize+', '+fileSuffix,
                        Thumb: fileidlist[uuid].host + fileidlist[uuid].filename,
                    }
                    filecon.Url = fileidlist[uuid].host + fileidlist[uuid].filename
                }

                let suuid = uploadfile.generateUUID()
                filecon = JSON.stringify(filecon)
                // filecon = base64.b64EncodeUnicode(filecon)
                this.MSGID(suuid) //保存uuid

                this.socketApi.sendSock({
                    msgType: "TALK_TO_FRIEND_REQ",
                    msgContent: {
                        weChatId: this.selectfriendids.wechatContactinfo.wechatid,
                        friendId: this.selectfriendids.wechatContactinfo.friendid,
                        contentType: contenttype,
                        content: filecon,
                        sendUuid: suuid
                    }
                })
            },
            // 上传失败回调
            uploadError(res) {
                console.log(res, '上传失败')
            },
            // 文本域获取光标
            textareafocus() {
                document.querySelector('.chatinput').focus()
            },
            // 添加好友弹窗
            addfriendshow(id) {
                this.msgId = id
                let initBusType = localStorage.getItem('initBusType')

                if (initBusType == 'INNER_CRM') {
                    //this.addleft = 'left:' + window.parent.document.body.clientWidth / 2 + 'px'
                    window.parent.postMessage({
                        type: 'addFriend',
                        friendid: this.selectfriendids.wechatContactinfo.friendid,
                        outsideCustomerId: this.selectfriendids.wechatContactinfo.outsideCustomerId
                    }, '*')
                } else {
                    this.showaddfriend = true
                }
            },
            // 添加好友接口
            addWxFriends() {
                this.$post(friendVerification, {
                    "wechatId": this.selectfriendids.wechatContactinfo.wechatid,
                    "friendId": this.selectfriendids.wechatContactinfo.friendid,
                    "msgId": this.msgId,
                    "messageContent": this.addMessage
                }).then(res => {
                    if (res.data.code == 200) {
                        this.$message({
                            message: '发送请求成功',
                            type: 'success'
                        });
                    } else {
                        this.$message.error(res.data.msg);
                    }
                    this.addMessage = ''
                    this.showaddfriend = false

                })
            },
            // 标签数据格式化
            group(array, subGroupLength) {
                let index = 0;
                let newArray = [];
                while (index < array.length) {
                    newArray.push(array.slice(index, index += subGroupLength));
                }
                return newArray;
            },
            // 预览图片数据处理
            getsrcList(url, id, curl) {
                let lurl = url;
                console.log(curl)
                this.$nextTick(() => {
                    let dom = $('.el-icon-download');
                    if (dom) {
                        dom.remove()
                    }
                    let str = document.createElement("i")
                    str.setAttribute('class', 'el-icon-download')
                    let _this = this;
                    $('.el-image-viewer__actions__inner').append(str)
                    $('.el-image-viewer__actions__inner .el-icon-download').on('click',function(){
                        _this.downloadIamge(lurl)
                    })
                })
            },
            // 下载图片
            downloadIamge(imgsrc, name) { //下载图片地址和图片名
                let image = new Image();
                // 解决跨域 Canvas 污染问题
                image.setAttribute("crossOrigin", "Anonymous");
                let _this = this;
                image.src = imgsrc;
                image.onload = function() {
                    var canvas = document.createElement("canvas");
                    canvas.width = image.width;
                    canvas.height = image.height;
                    var context = canvas.getContext("2d");
                    context.drawImage(image, 0, 0, image.width, image.height);
                    var url = canvas.toDataURL("image/png"); //得到图片的base64编码数据
                    var a = document.createElement("a"); // 生成一个a元素
                    var event = new MouseEvent("click"); // 创建一个单击事件
                    a.download = ''; // 设置图片名称
                    var blob = _this.dataURLtoBlob(url);
                    var objurl = URL.createObjectURL(blob);
                    a.href = objurl; // 将生成的URL设置为a.href属性
                    a.dispatchEvent(event); // 触发a的单击事件
                };
            },
            // toblob
            dataURLtoBlob(dataurl) {
                var arr = dataurl.split(','),
                    mime = arr[0].match(/:(.*?);/)[1],
                    bstr = atob(arr[1]),
                    n = bstr.length,
                    u8arr = new Uint8Array(n);
                while (n--) {
                    u8arr[n] = bstr.charCodeAt(n);
                }
                return new Blob([u8arr], {
                    type: mime
                });
            },
            // 音频处理
            playamr(val, id) {
                if (!val) {
                    this.getUrl(id,true)
                    return false
                }
                let audiodom = document.getElementById('audio' + id)
                let olddom = document.getElementById('audio' + this.audioid)
                if (this.audioid == id) {
                    if (audiodom.paused) {
                        this.audioid = id;
                        audiodom.play(); //播放

                    } else {
                        audiodom.pause(); //暂停
                    }
                } else {
                    if (this.audioid != '0') {
                        olddom.pause();
                    }
                    audiodom.play(); //播放
                    this.audioid = id;
                    let _this = this
                    audiodom.addEventListener('ended', function() {
                        _this.audioid = 0
                    }, false);
                }
            },
            // 视频处理
            playvideo(val, id) {
                if (!val) {
                    this.getUrl(id,true)
                    return false
                }
                console.log(id,'videodom')
                let videodom = document.getElementById('video' + id)
                let olddom = document.getElementById('video' + this.videoid)
                if (this.videoid == id) {
                    if (videodom.paused) {
                        this.videoid = id;
                    } else {
                        videodom.pause(); //暂停
                    }
                } else {
                    if (this.videoid != '0' && olddom) {
                        olddom.pause();
                    }
                    videodom.play(); //播放
                    this.videoid = id;
                    let _this = this
                    videodom.addEventListener('ended', function() {
                        _this.videoid = 0
                    }, false);
                }
            },

            //更多聊天记录
            getmoreHistoryWechatMessage() {
                if (this.ismore) {
                    this.ismore = false;
                    this.wxSendTime = this.selectfriendids.wechatMessage.data[0].wxSendTime;
                    this.getHistoryWechatMessage({
                        "endDateTime": this.timerange ? this.timerange[1] : '',
                        "friendid": this.selectfriendids.wechatContactinfo.friendid,
                        "wxSendTime": this.wxSendTime,
                        "startDateTime": this.timerange ? this.timerange[0] : '',
                        "wechatid": this.selectfriendids.wechatContactinfo.wechatid
                    })
                }

            },
            // 选择时间搜聊天记录
            selecttime() {
                //显示搜索结果issearchtime= true
                this.selbtn = 1;
                this.issearchtime = true;
                this.wxSendTime = '';
                let friendid, wechatid;
                if (this.showchatdailg == 1) {
                    friendid = this.selectfriendids.wechatContactinfo.friendid
                    wechatid = this.selectfriendids.wechatContactinfo.wechatid
                } else {
                    friendid = this.chatdata.wechatContactinfo.friendid
                    wechatid = this.chatdata.wechatContactinfo.wechatid
                }
                console.log(this.timerange)
                sessionStorage.setItem('timerange', JSON.stringify(this.timerange))
                //请求聊天记录
                this.getHistoryWechatMessage({
                    "endDateTime": this.timerange ? this.timerange[1] : '',
                    "friendid": friendid,
                    "wxSendTime": this.wxSendTime,
                    "startDateTime": this.timerange ? this.timerange[0] : '',
                    "wechatid": wechatid
                })
            },

            getHistoryWechatMessage(msg) {
                //查询聊天记录
                this.$post(findHistoryWechatMessage, msg).then(res => {
                    // if (msg.id != 0) {
                    this.nomore = true
                    if (res.data.data == undefined) {
                        this.ismore = false
                        return false;
                    }
                    if (res.data.data.length == 0 && !this.timerange) {
                        this.ismore = false //查询更多记录无隐藏更多按钮
                        this.wxSendTime = ''; //id恢复0
                    } else if (res.data.data.length < 20 && res.data.data.length != 0) {
                        this.ismore = false
                    } else {
                        this.nomore = false
                        setTimeout(() => {
                            this.ismore = true
                        }, 300)
                    }
                    this.setHistoryWechatMessage(res.data.data)
                    //更新好友列表备注
                    if (res.data.data && res.data.data.length != 0) {

                        let olddata = this.chatlist;
                        for (let i = 0; i < olddata.records.length; i++) {
                            for (let j = 0; j < res.data.data.length; j++) {
                                if (olddata.records[i].friendid == res.data.data[j].friendid && res.data.data[j]
                                    .isSend == "false" && olddata.records[i].wechatid == res.data.data[j].wechatid
                                ) {
                                    olddata.records[i].remark = res.data.data[j].remark
                                    this.SELECTCHAT(olddata)
                                    return false
                                }
                            }

                        }

                    }

                })
            },

            setHistoryWechatMessage(data) {
                if (data.length == 0) {
                    if (this.selbtn == 1) {
                        this.SELECTFRIENDDATA({
                            wxSendTime: '',
                            data: []
                        })
                        this.selbtn == 0
                    }
                    return false;
                }
                let dataarr = data.reverse()
                //存储聊天记录
                if (this.showchatdailg == 1) {
                    let wechatdata = this.selectfriendids.wechatMessage.data;
                    if (this.issearchtime) {
                        //聊天内容拉到顶部
                        if (this.timerange) {
                            if (this.wxSendTime == '') {
                                wechatdata = dataarr
                                if (data.length == 20) {
                                    this.wxSendTime = data[0].wxSendTime //加载更多
                                }
                                this.SELECTFRIENDDATA({
                                    wxSendTime: this.wxSendTime,
                                    data: wechatdata
                                })
                                this.scrollbottom()
                            } else {
                                if (data.length == 20) {
                                    this.wxSendTime = data[0].wxSendTime //加载更多
                                } else {
                                    this.wxSendTime = ''
                                }
                                wechatdata = dataarr.concat(wechatdata)
                                this.SELECTFRIENDDATA({
                                    wxSendTime: this.wxSendTime,
                                    data: wechatdata
                                })
                                let div = this.$refs['scrollbar'].$refs['wrap'];
                                this.$nextTick(() => {
                                    div.scrollTop = div.scrollHeight - this.msgscrolltop
                                })
                            }

                            //设置当前聊天状态为查找聊天记录状态
                            this.CHATSTATE(false)
                        } else {
                            this.SELECTFRIENDDATA({
                                wxSendTime: this.wxSendTime,
                                data: dataarr
                            })
                            console.log('置顶好友会话')
                            this.addnewchat(this.selectfriendids.wechatContactinfo.friendid,this.selectfriendids.wechatContactinfo.wechatid)
                            this.scrollbottom()
                            //设置当前聊天状态为正在聊天状态
                            this.CHATSTATE(true)
                            this.issearchtime = false;
                        }

                    } else {
                        if (wechatdata.length == 0) {
                            wechatdata = dataarr
                            this.SELECTFRIENDDATA({
                                wxSendTime: this.wxSendTime,
                                data: wechatdata
                            })
                            this.$nextTick(() => {
                                div.scrollTop = div.scrollHeight
                            })
                        } else {
                            wechatdata = dataarr.concat(wechatdata)
                            this.SELECTFRIENDDATA({
                                wxSendTime: this.wxSendTime,
                                data: wechatdata
                            })
                            let div = this.$refs['scrollbar'].$refs['wrap'];
                            this.$nextTick(() => {
                                div.scrollTop = div.scrollHeight - this.msgscrolltop
                            })
                        }

                    }
                } else {
                    let wechatdata = this.chatdata.wechatMessage.data;
                    wechatdata.length == 0 ? wechatdata = dataarr : wechatdata = dataarr.concat(wechatdata)
                    let wechatMessage = {
                        wxSendTime: this.wxSendTime,
                        data: wechatdata
                    }
                    //传给父组件
                    this.$emit('setchatmsg', wechatMessage)
                }

            },

            //点击选择聊天记录index换成数据
            selectchat(item) {
                const arr = {...this.chatdata}
                let carr = []
                arr.wechatMessage.data.forEach(v => {
                    if(v.select){
                        carr.push(v)
                    }
                })
                if(carr.length == 10 && !item.select){
                    this.$toast('最多只能选择10条消息')
                    return false
                }
                const checkdata = this.checkmsg(item)
                if(checkdata.flag){
                    arr.wechatMessage.data.forEach(v => {
                        if(item.id == v.id){
                            v.select = !v.select
                        }
                    })
                    this.SELECTFRIEND(arr)
                    console.log(this.chatdata.wechatMessage,'wechatMessage')
                }else{
                    this.$toast(checkdata.msg)
                }
            },

            //确定选择的聊天记录
            sendchathistorymsg() {
            },



            savetip(){
                let arr = new Array()
                for(let i = 0;i<this.tiplist.length;i++){
                    if(this.tiplist[i].act==1){
                        arr.push({
                            tagId:this.tiplist[i].id,
                            wechatContactinfoId:this.usermsg.id
                        })
                    }
                }
                this.$post(editFriendTag,arr).then(res=>{
                    if(res.data.code ==200){
                        this.showtips = true
                        this.remarkVisible = false
                    }else{
                         this.$message.error('保存失败');
                    }
                })

            },

            seltip(id){
                for(let i = 0;i<this.tiplist.length;i++){
                    if(this.tiplist[i].id==id){
                        if(this.tiplist[i].act == 1){
                            this.tiplist[i].act =0
                        }else{
                            this.tiplist[i].act =1
                        }
                    }
                }
                let str = JSON.stringify(this.tiplist)
                this.tiplist = JSON.parse(str)
            },

            oppenFile() {
                this.showFile = !this.showFile
            },

            //关闭聊天弹窗
            closechat() {
                this.$emit('closechat')
            },

            showtoast() {
                this.$toast('showtoast');
            },

            //显示修改备注弹窗
            showremark(msg) {
                if (msg == 'true') {
                    return false
                }
                this.showtips = true
                this.oldtips = {
                    str:'',
                    arr:[]
                }
                this.$post(friendInfo, {
                    id: this.selectfriendids.wechatContactinfo.id
                }).then(res => {
                    if (res.status == 200) {
                        this.usermsg = res.data.data
                        this.oldremark = this.usermsg.remark
                        this.remarkVisible = true
                        this.showeditremark = false;
                        if(this.usermsg.friendTagList && this.usermsg.friendTagList.length>0 ){
                            let arr = []
                            for(let i=0;i<this.usermsg.friendTagList.length;i++){
                                arr.push(this.usermsg.friendTagList[i].tagName)
                            }
                            this.oldtips ={
                                str:arr.join(';'),
                                arr:res.data.data.friendTagList
                            }
                        }
                    } else {
                        this.$message.error(res.data.msg);
                    }
                })
            },

            closeremrk(){
                this.remarkVisible = false
            },

            //修改备注
            editremark() {
                this.showeditremark = true;
                this.$nextTick(function() {
                    this.$refs.nickinput.focus()
                })
            },

            gettips(){
                this.showtips = false
                this.$get(getFriendTag).then(res=>{

                    this.tiplist = res.data.data
                    for(let i=0;i< this.tiplist.length;i++){
                        this.tiplist[i].act =0
                        for(let j=0;j< this.oldtips.arr.length;j++){
                            if(this.oldtips.arr[j].id == this.tiplist[i].id){
                                this.tiplist[i].act =1
                            }
                        }
                    }
                })
            },

            //保存备注
            saveremark() {
                this.$post(editWechatContactinfoRemark, {
                    friendid: this.usermsg.friendid,
                    remark: this.oldremark,
                    wechatid: this.usermsg.wechatid
                }).then(res => {
                    if (res.data.code == 200) {
                        //更新会话好友信息
                        let olddata = this.chatlist;
                        for (let i = 0; i < olddata.records.length; i++) {
                            if (olddata.records[i].friendid == this.usermsg.friendid && olddata.records[i].wechatid ==
                                this.usermsg.wechatid) {
                                olddata.records[i].remark = this.oldremark
                            }
                        }
                        this.usermsg.remark = this.oldremark
                        this.SELECTCHAT(olddata)
                        this.SELECTFRIENDINFO(this.usermsg)
                        this.$message({
                            message: '修改成功！',
                            type: 'success'
                        });
                        setTimeout(() => {
                            this.remarkVisible = false;
                        }, 500)
                    } else {
                        this.$message.error(res.data.msg);
                    }
                })
            },

            // 输入表情
            addexpression(index) {
                let face = this.selectExpression(index)
                const value = this.chatValue
                const newValue = // 拼接
                    value.substring(0, this.startPos) +
                    face +
                    value.substring(this.endPos, value.length)
                this.chatValue = newValue
                // 重置光标位置紧跟在表情文本后面
                let el = this.$refs.textarea;
                if (el.setSelectionRange) {
                    setTimeout(() => {
                        const index = this.startPos + face.length
                        el.setSelectionRange(index, index)
                        el.focus()
                    }, 0)
                }
                this.toolsContent.contentType = 1
                // this.toolsContent.name = ''
                // this.toolsContent.size = 0
                // this.toolsContent.fileType = ''
                //this.$emit('tools-content', this.toolsContent)
                // this.toolsContent = {}
            },

            // 选择表情
            selectExpression(val) {
                this.showexpression = false
                let rm = this.facedata.expressionMap[val]
                let qqList = [113, 114, 115, 116, 117, 118, 124, 125]
                // qq表情
                if (rm) {
                    if (val < 105 || qqList.indexOf(val) >= 0) {
                        rm = '[' + this.facedata.expressionMap[val] + ']'
                    } else {
                        rm = '<' + rm + '>'
                        rm = this.facedata.emojiMap[rm]
                        // let en = '😁'
                        // let encode = en.codePointAt(0)
                        let rmencode = parseInt(rm, 16)
                        rm = String.fromCodePoint(rmencode)
                    }
                    return rm
                } else {
                    console.log('无效选择')
                    return ''
                }
            },

            // 记录光标位置
            resetpos() {
                let elInput = this.$refs.textarea;
                let startPos = elInput.selectionStart;
                let endPos = elInput.selectionEnd;
                this.startPos = startPos;
                this.endPos = endPos;
            },

            //回车禁止换行
            listen(event) {
                if (event.keyCode === 13) {
                    event.preventDefault() // 阻止浏览器默认换行操作
                    this.sendmsg() // 发送文本
                    return false
                }
            },

            //发送聊天内容
            sendmsg() {
                this.chatValue = this.chatValue.replace(/(^\s*)|(\s*$)/g, "")
                let fdata = this.selectfriendids;
                let txtcon = this.chatValue;
                if (event.keyCode === 13) {
                    event.preventDefault() // 阻止浏览器默认换行操作
                    txtcon = JSON.stringify(txtcon)
                    let str = txtcon.substring(txtcon.length - 3, txtcon.length - 1)
                    if (/\\n/.test(str)) {
                        txtcon = txtcon.substring(0, txtcon.length - 3) + '"'
                    }
                    txtcon = JSON.parse(txtcon)
                }
                if (this.chatValue == '') {
                    return false;
                }
                let uuid = uploadfile.generateUUID()
                const sloading = this.$loading({
                  lock: true,
                  spinner: 'el-icon-loading',
                  background: 'rgba(255, 255, 255, 0)'
                });
                this.$post(messageSensitiveCheck, {
                    wechatid: this.selectfriendids.wechatContactinfo.wechatid,
                    friendid: this.selectfriendids.wechatContactinfo.friendid,
                    contentType: this.toolsContent.contentType,
                    content: txtcon,
                    sendUuid: uuid
                }).then((res) => {
                    sloading.close()
                    if (res.data.code == 200) {
                        let sendStatus = 1
                        // txtcon = base64.b64EncodeUnicode(txtcon)
                        console.log(txtcon,'发送前打印的',uuid)
                        if (res.data.data.handleType == 0) {
                            this.$confirm('此信息包含敏感词【'+res.data.data.sensitiveName+'】，请谨慎发送', '提示', {
                                confirmButtonText: '发送',
                                cancelButtonText: '取消',
                                type: 'warning'
                            }).then(() => {
                                this.MSGID(uuid) //保存uuid
                                this.socketApi.sendSock({
                                    msgType: "TALK_TO_FRIEND_REQ",
                                    msgContent: {
                                        weChatId: this.selectfriendids.wechatContactinfo.wechatid,
                                        friendId: this.selectfriendids.wechatContactinfo.friendid,
                                        contentType: this.toolsContent.contentType,
                                        content: txtcon,
                                        sendUuid: uuid,
                                        sendStatus:sendStatus
                                    }
                                })
                                this.chatValue = '' //发送内容后清空输入内容
                                this.showexpression = false
                            })
                            return false
                        }
                        let sensitiveName = ''
                        if (res.data.data.handleType == 1) {
                            sendStatus = 3
                            // sensitiveName = res.data.data.sensitiveName
                        }
                        this.MSGID(uuid) //保存uuid
                        this.socketApi.sendSock({
                            msgType: "TALK_TO_FRIEND_REQ",
                            msgContent: {
                                weChatId: this.selectfriendids.wechatContactinfo.wechatid,
                                friendId: this.selectfriendids.wechatContactinfo.friendid,
                                contentType: this.toolsContent.contentType,
                                content: txtcon,
                                sendUuid: uuid,
                                sendStatus:sendStatus,
                                // sensitiveName:sensitiveName
                            }
                        })
                        this.chatValue = '' //发送内容后清空输入内容
                        this.showexpression = false
                    }else{
                        this.$message.error('敏感词检测失败！');
                    }
                })

            },

            addnewchat(fid,wid) {
                let oldArr = this.chatlist;
                let addtofrist = {};
                let top = 0
                if (oldArr) {
                    let n =0
                    let ntop = 0
                    for (var i = 0; i < oldArr.records.length; i++) {
                        if(oldArr.records[i].top){
                            ntop = ntop + 1
                        }
                        if (oldArr.records[i].friendid === fid && oldArr.records[i].wechatid === wid) {
                            n = i
                            top = oldArr.records[i].top
                            addtofrist = {...oldArr.records[i]}
                        }
                    }
                    addtofrist.unReadCount = 0;
                    oldArr.records.splice(n, 1); // 如果数据组存在该元素，则把该元素删除
                    if(top){
                        oldArr.records.splice(0,0,addtofrist); // 再添加到第一个位置
                    }else{
                        oldArr.records.splice(ntop,0,addtofrist); // 再添加到第一个位置
                    }
                    this.SELECTCHAT(oldArr)
                } else {
                    //无会话列表信息，控制台提示
                }
            },
            //
            scrollbottom() {
                //聊天内容拉到最下面
                setTimeout(res => {
                    let div = this.$refs['scrollbar'].$refs['wrap'];
                    this.$nextTick(() => {
                        div.scrollTop = div.scrollHeight
                        this.msgscrolltop = div.scrollHeight
                    })
                },10)
            },

            documentarystate() {
                window.parent.postMessage({
                    type: 'toggle',
                    state: this.getdocumentary
                }, '*')
                this.SETDOC(!this.getdocumentary)
            }

        }
    };
</script>
<style lang="less" scoped>
    .newloading{
        .mask{
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0,0,0,0.4);
            z-index: 999;
        }
        .con{
            position: fixed;
            top: 50%;
            left: 50%;
            transform: translate(-50%,-50%);
            width: 244px;
            height: 120px;
            z-index: 1000;
            background: #000;
            border-radius: 4px;
            text-align: center;
            p{
                color: #fff;
                margin: 28px 0 18px;
                font-size: 16px;
            }
            img{
                width: 30px;
                height: 30px;
                animation: loadrotate 1.5s linear infinite;
                transform: rotate(180deg);
            }
            @keyframes loadrotate {
                from{
                    transform: rotate(0deg);
                }
                to{
                    transform: rotate(-360deg);
                }
            }
        }
    }
    .addfriend_box {

        .addfriend_con {
            position: fixed;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 360px;
            height: 220px;
            padding: 30px;
            background: #fff;
            box-shadow: 0px 0px 18px 0px rgba(5, 2, 2, 0.28);
            border-radius: 6px;
            z-index: 99999;

            .tit {
                font-size: 16px;
                line-height: 22px;
                color: #333;

                a {
                    display: block;
                    float: right;
                    color: #93999F;
                }
            }

            textarea {
                width: 336px;
                height: 67px;
                margin-top: 28px;
                padding: 14px 12px;
                resize: none;
                background: rgba(226, 231, 235, 0.2);
                border: 1px solid rgba(226, 231, 235, 1);
                border-radius: 2px;
                outline: none;

                &:focus {
                    border: 1px solid rgba(0, 153, 255, 1);
                }
            }

            .tip {
                font-size: 12px;
                color: #B5B9BC;
                margin-top: 10px;
            }

            .btn_box {
                margin-top: 30px;

                a {
                    width: 76px;
                    height: 30px;
                    text-align: center;
                    line-height: 30px;
                    border: 1px solid rgba(218, 222, 224, 1);
                    border-radius: 2px;
                    float: right;
                    margin-left: 10px;
                    font-size: 14px;
                    color: #93999F;
                }

                .btn_ok {
                    border: 1px solid #0099FF;
                    background: #0099FF;
                    color: #fff;
                }
            }
        }
    }

    /* 聊天窗选择*/
    .sendbtnbox{
        display: none;
    }
    .selectchatmsg {
        background: #F3F5F7;

        .chatCon {

            li {
                position: relative;
                padding-left: 50px;
                &:hover {
                    background: rgba(28, 35, 43, 0.03);
                }
                .chatmsg {

                    &>i {
                        display: block;
                        position: absolute;
                        top: 25px;
                        left: 20px;
                        width: 16px;
                        height: 16px;
                        background: url(/static/img/icon_nosel.png) center no-repeat;
                        background-size: 16px 16px;
                        &:hover,&.active {
                            border-radius: 50%;
                            cursor: pointer;
                            background: url(/static/img/icon_sel.png ) center no-repeat;
                            background-size: 16px 16px;
                        }
                    }
                }
            }
        }

        .sendbtnbox{
            border-top: 1px solid #E1E6F0;
            height: 180px;
            display: flex;
            justify-content: center;
            align-items: center;
            position: absolute;
            bottom: 0;
            width: 100%;
            background: #F8F9FA;
            padding-top: 5px;

            .zfbox{
                position: relative;
                p{
                    position: absolute;
                    bottom: -25px;
                    color: #2a2a2a;
                    font-size: 12px;
                }
            }

            img{
                cursor: pointer;
                width: 17px;
                height: 17px;
                &:first-child{
                    width: 48px;
                    height: 48px;
                    margin-right: 35px;
                }
            }

        }
    }

    /* 聊天窗口 */
    .chat {
        height: calc(100vh - 50px);
        min-width: 420px;
        background: #fff;
        position: relative;

        .bindwx{
            position: absolute;
            top: 0;
            right: 0;
            line-height: 48px;
            display: flex;
            align-items: center;

            .bindname{
                margin:0 12px 0 5px;
                height: 48px;
                width: 60px;
                overflow: hidden;
                text-overflow:ellipsis;
                white-space: nowrap;
            }
        }

        // 置顶
        .send_item {
            line-height: 24px;
            text-align: center;
            height: 24px;
            cursor: pointer;
            font-size: 12px;
            &:hover {
                background-color: #008AFF;
                color: white;
            }
        }

        .sendtools {
            width: 88px;
            position: fixed;
            background-color: #F0F1F2;
            border-radius: 4px;
            overflow: hidden;
            z-index: 99;
            box-shadow:0px 0px 12px 0px rgba(13,18,30,0.1);
        }

        /* 跟单按钮*/
        .btn_documentary {
            width: 19px;
            height: 62px;
            line-height: 62px;
            font-size: 20px;
            background: #fff;
            color: #000;
            border-radius: 12px 0px 0px 12px;
            display: block;
            position: absolute;
            top: 50%;
            right: 0px;
            transform: translateY(-50%);
        }

        /* 默认头部样式*/
        .title {
            height: 48px;
            line-height: 48px;
            position: relative;
            background: #fff;

            .txt {
                padding-left: 20px;
            }

            /* 关闭按钮*/
            .btn_close {
                width: 12px;
                height: 12px;
                position: absolute;
                top: 18px;
                right: 18px;
            }

        }

        /* 时间组件微调*/
        .timeSelect {

            .el-date-editor--datetimerange.el-input,
            .el-date-editor--datetimerange.el-input__inner {
                width: 300px;
            }

            .el-input__inner {
                border: none;
            }

            .el-range-editor.is-active,
            .el-range-editor.is-active:hover {
                color: #fff;
            }
        }

        /* 聊天主体*/
        .chatCon {
            background: #F3F5F7;
            height: calc(100vh - 290px);
            // min-height: 160px;

            /* 查看更多按钮*/
            .btn_moreinfo {
                height: 18px;
                font-size: 12px;
                font-weight: 400;
                color: rgba(0, 153, 255, 0.8);
                line-height: 18px;
                display: block;
                text-align: center;
                padding-top: 18px;
            }

            .searchResult {
                margin-top: 20px;
            }

            .searchResult p,
            .time {
                color: #707478;
                font-size: 12px;
                text-align: center;
                line-height: 18px;
            }

            /* 消息列表*/
            .chatlist {

                &.sel_state {
                    padding-left: 50px;
                    li {
                        &>i {
                            display: block;
                        }
                    }
                }

                li {
                    position: relative;

                    &>.time {
                        margin: 14px 0;
                    }

                    .chattip {
                        padding: 20px 40px;
                        line-height: 30px;
                        font-size: 12px;
                        color: #707478;
                        text-align: center;

                        i {
                            color: #0099FF;
                            cursor: pointer;
                        }
                        .red_state{
                            margin-top: 12px;
                            color: #2A2A2A;
                            img{
                                height: 20px;
                                width: 20px;
                                vertical-align: middle;
                            }
                            span{
                                color: #ECA235;
                            }
                        }
                    }



                    .chatmsg {
                        padding: 16px 40px 16px 20px;

                        &>img {
                            width: 36px;
                            height: 36px;
                            border-radius: 50%;
                        }

                        .chatred_con{
                            width: 221px;
                            height: 82px;
                            position: relative;
                            cursor: pointer;

                            .chatred{
                                position: absolute;
                                top: 10px;
                                left: 67px;
                                color: #fff;
                                .tit{
                                    font-size: 14px;
                                    font-weight: bold;
                                    width: 140px;
                                    height: 20px;
                                    line-height: 20px;
                                    overflow: hidden;
                                    text-overflow:ellipsis;
                                    white-space: nowrap;
                                }
                                .state{
                                    margin-top: 5px;
                                    font-size: 12px;
                                }
                            }
                        }

                        .chattxt {
                            font-size: 12px;
                            font-weight: 400;
                            line-height: 18px;
                            border-radius: 3px;
                            max-width: 375px;
                            padding: 10px 15px;
                            position: relative;
                            word-wrap: break-word;

                            &::after {
                                content: '';
                                position: absolute;
                                top: 12px;
                                width: 0;
                                height: 0;
                                border-width: 7px;
                                border-style: solid;
                            }

                            i {
                                position: absolute;
                                left: -40px;
                                color: #000000;
                                font-size: 18px;
                                top: 50%;
                                transform: translateY(-50%);
                            }

                            .loading {
                                top: 50%;
                                font-size: 16px;
                                margin-top: -8px;
                            }


                            .ic_err {
                                color: firebrick;
                            }

                            .audiobtn {
                                min-width: 80px;
                                width: 100%;
                                height: 40px;
                                cursor: pointer;
                                position: relative;

                                em {
                                    position: absolute;
                                    top: 10px;
                                    color: #333;
                                }

                                audio {
                                    display: none;
                                }

                                .audio_dot{
                                    position: absolute;
                                    width: 8px;
                                    height: 8px;
                                    top: 0;
                                    background: #E64340;
                                    border-radius: 50%;
                                }

                                .audio_loading{
                                    position: absolute;
                                    font-size: 16px;
                                    margin-top: -8px;
                                    top: 50%;
                                    color: #000;
                                }
                            }

                            .videobox {
                                position: relative;
                                max-width: 375px;

                                a {
                                    position: absolute;
                                    left: 50%;
                                    top: 50%;
                                    display: block;
                                    transform: translate(-50%, -50%);
                                    width: 40px;
                                    height: 40px;
                                    background: url(/static/img/play_icon1.png) center no-repeat;
                                    background-size: 100% 100%;
                                }

                                .btn-download{
                                    position: absolute;
                                    left: 50%;
                                    top: 50%;
                                    transform: translate(-50%, -50%);
                                    img{
                                        width: 40px;
                                        height: 40px;
                                    }
                                }
                            }

                            .chat_yp,.chat_sp{
                                display: inline-block;
                                vertical-align: text-bottom;
                                width: 24px;
                                height: 18px;
                                background: url(/static/img/icon_yp_r.png) center no-repeat;
                                background-size: 24px 12px;
                                margin-left: 8px;
                            }
                            .chat_sp{
                                background: url(/static/img/icon_sp_r.png) center no-repeat;
                                background-size: 24px 18px;
                            }

                            .imgshowbox{
                                position: relative;
                                .btn-download{
                                    position: absolute;
                                    top: 0;
                                    left: 0;
                                    width: 100%;
                                    height: 100%;
                                    img{
                                        position: absolute;
                                        top: 50%;
                                        left: 50%;
                                        transform: translate(-50%,-50%);
                                        width: 40px;
                                        height: 40px;
                                        cursor: pointer;
                                    }
                                }
                                .chattxt{
                                    margin: 0;
                                }
                            }


                        }

                        .chatlink {
                            position: relative;
                            &::after {
                                display: none;
                            }

                            a {
                                display: block;

                                .linktitle {
                                    font-size: 14px;
                                    line-height: 19px;
                                    width: 280px;
                                    margin-bottom: 10px;
                                    color: #333;
                                    text-overflow: -o-ellipsis-lastline;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                    display: -webkit-box;
                                    -webkit-line-clamp: 2;
                                    -webkit-box-orient: vertical;

                                    &:hover {
                                        color: #0099FF;
                                    }
                                }

                                .linkdes {
                                    font-size: 12px;
                                    line-height: 18px;
                                    width: 206px;
                                    color: #93999F;
                                    text-overflow: -o-ellipsis-lastline;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                    display: -webkit-box;
                                    -webkit-line-clamp: 3;
                                    -webkit-box-orient: vertical;
                                }

                                .linkimg {
                                    width: 50px;
                                    height: 50px;
                                }

                                &.btn_dfile{
                                    position: absolute;
                                    width: 20px;
                                    height: 20px;
                                    top:50%;
                                    transform: translateY(-50%);
                                    background: url(/static/img/icon_dfile.png) no-repeat;
                                    background-size: contain;
                                }
                            }

                            .audio_loading{
                                position: absolute;
                                top:50%;
                                font-size: 16px;
                                margin-top: -8px;
                                color: #000;
                            }

                            &.nop {
                                padding: 0;
                            }

                            .chatfile{
                                position: relative;

                                b{
                                    position: absolute;
                                    top: 50%;
                                    transform: translateY(-50%);
                                    left: 0;
                                    display: block;
                                    font-size: 38px;
                                    color: blue;
                                }

                                .chatfile_doc{
                                    color: #5DACFF;
                                }

                                .chatfile_xls{
                                    color: #5ACC9B;
                                }
                                .chatfile_ppt{
                                    color: #FF8A76;
                                }
                                .chatfile_pdf{
                                    color: #FF6969;
                                }
                            }
                        }

                        .chatother {
                            padding: 0;
                            min-height: 40px;
                            min-width: 50px;
                            text-align: center;

                            &::after {
                                display: none;
                            }

                            video {
                                width: 375px;
                                vertical-align: middle;
                            }

                            img {
                                max-width: 375px;
                                vertical-align: middle;
                            }
                        }

                        .chataudio {
                            &::after {
                                display: block;
                            }
                        }

                        .chatbot {
                            padding-top: 8px;

                            span {
                                font-size: 12px;
                                line-height: 18px;
                            }

                            .name {
                                color: #93999F;
                            }

                            .time {
                                color: #B5B9BC;
                            }
                        }
                    }
                }

                /* 收到的消息*/
                .chatreceive {
                    .chatmsg {

                        &>img {
                            float: left;
                        }

                        .chattxt {
                            background: #E6E8EC;
                            color: #4C4C4C;
                            float: left;
                            margin-left: 15px;

                            &::after {
                                left: -14px;
                                border-color: transparent #E6E8EC transparent transparent;
                            }

                            .audiobtn {
                                em {
                                    right: -20px;
                                }

                                .wifi-symbol {
                                    transform: rotate(135deg) scale(0.6);
                                    right: -15px;
                                }

                                .audio_dot{
                                    right: -16px;
                                }
                                .audio_loading{
                                    right: -46px;
                                }
                            }

                            .loading {
                                left: auto;
                                right: -30px;
                            }

                            .chat_yp {
                                float: left;
                                background: url(/static/img/icon_yp_l.png) center no-repeat;
                                background-size: 24px 12px;
                            }

                            .chat_sp{
                                float: left;
                                margin-right: 8px;
                                background: url(/static/img/icon_sp_l.png) center no-repeat;
                                background-size: 24px 18px;
                            }
                        }

                        .chatlink {
                            background: #fff;

                            &::after {
                                border-color: transparent #fff transparent transparent;
                            }

                            .chatfile {
                                padding-right: 50px;

                                b{
                                    left:auto;
                                    right: 0;
                                }

                                p{
                                    font-size: 14px;
                                    color: #2A2A2A;
                                    width: 189px;
                                    text-overflow: -o-ellipsis-lastline;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                    display: -webkit-box;
                                    -webkit-line-clamp: 2;
                                    -webkit-box-orient: vertical;
                                    line-height: 20px;
                                }
                                span{
                                    font-size: 12px;
                                    color: #93999F;
                                    line-height: 20px;
                                }
                            }

                            .btn_dfile,.audio_loading{
                                right: -30px;
                            }
                        }

                        .chatbot {
                            clear: both;
                            margin-left: 58px;

                            .name {
                                float: left;
                            }

                            .time {
                                float: left;
                                margin-left: 10px;
                            }
                        }

                        .chatred_con{
                            background: url(/static/img/red_l.png) no-repeat;
                            background-size: 100% 100%;
                            margin-left: 47px;
                            position: relative;
                            &.active{
                                background: url(/static/img/red_l_o.png) no-repeat;
                                background-size: 100% 100%;
                            }
                        }
                        .red_state{
                            float: left;
                            margin-left: 47px;
                        }
                    }

                }

                /* 发送的消息*/
                .chatsend {
                    .chatmsg {
                        &>img {
                            float: right;
                        }

                        .chattxt {
                            float: right;
                            background: linear-gradient(90deg, rgba(46, 140, 228, 1), rgba(23, 129, 231, 1));
                            color: #fff;
                            margin-right: 15px;

                            &::after {
                                right: -14px;
                                border-color: transparent transparent transparent rgba(23, 129, 231, 1);
                            }

                            .audiobtn {
                                em {
                                    left: -20px;
                                }

                                .wifi-symbol {
                                    transform: rotate(-45deg) scale(0.6);
                                    left: -15px;
                                }

                                .wifi-circle {
                                    border: 5px solid rgba(255, 255, 255, 0.6);
                                }

                                .first {
                                    background: rgba(255, 255, 255, 0.4);
                                }

                                .audio_dot{
                                    left: -16px;
                                }
                                .audio_loading{
                                    left: -46px;
                                }
                            }
                        }

                        .chatlink {
                            background: #fff;

                            &::after {
                                border-color: transparent #fff transparent transparent;
                            }

                            .chatfile {
                                padding-left: 50px;

                                p{
                                    font-size: 14px;
                                    color: #2A2A2A;
                                    width: 189px;
                                    line-height: 20px;
                                }
                                span{
                                    font-size: 12px;
                                    color: #93999F;
                                    line-height: 20px;
                                }
                            }

                            .btn_dfile,.audio_loading{
                                left: -30px;
                            }
                        }

                        .chatbot {
                            clear: both;
                            margin-right: 58px;

                            .name {
                                float: right;
                                margin-left: 10px;
                            }

                            .time {
                                float: right;

                            }
                        }

                        .chatred_box {
                            float: right;
                            .chatred_con{
                                background: url(/static/img/red_r.png) no-repeat;
                                background-size: 100% 100%;
                                margin-right: 10px;
                                position: relative;
                                &.active{
                                    background: url(/static/img/red_r_o.png) no-repeat;
                                    background-size: 100% 100%;
                                }
                            }
                            .red_state{
                                float: right;
                                margin-right: 47px;
                            }
                        }
                    }
                }
            }
        }

        .cannosend {
            height: calc(100vh - 108px);
        }

        /* 输入框*/
        .textArea {
            height: 180px;
            border-top: 1px solid #E1E6F0;
            background: #F8F9FA;
            position: relative;

            .dropline {
                position: absolute;
                top: -1px;
                left: 0;
                width: 100%;
                height: 3px;
                cursor: row-resize;
                z-index: 1;
            }

            /* 表情框 */
            .expression {
                position: relative;

                .icon_bq_on {
                    background: url(/static/img/icon_bq_on.png) center no-repeat;
                    background-size: 100% 100%;
                }

                .icon_bq {
                    background: url(/static/img/icon_bq.png) center no-repeat;
                    background-size: 100% 100%;
                    &:hover{
                        .icon_bq_on
                    }
                }

                .icon_microphone_on{
                    background: url(/static/img/icon_yuyin_on.png) center no-repeat;
                    background-size: 100% 100%;
                }

                .icon_microphone{
                    background: url(/static/img/icon_yuyin.png) center no-repeat;
                    background-size: 100% 100%;
                    &:hover{
                        .icon_microphone_on
                    }
                }

                .icon_folder_add_on{
                    background: url(/static/img/icon_floder_on.png) center no-repeat;
                    background-size: 100% 100%;
                }
                .icon_folder_add {
                    position: relative;
                    background: url(/static/img/icon_floder.png) center no-repeat;
                    background-size: 100% 100%;

                    &:hover{
                        .icon_folder_add_on
                    }

                    input {
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        opacity: 0;
                        font-size: 0 !important;
                        cursor: pointer;
                    }
                }

                .icon_syschat_on{
                    background: url(/static/img/icon_syschat_on.png) center no-repeat;
                    background-size: 100% 100%;
                }

                .icon_syschat{
                    background: url(/static/img/icon_syschat.png) center no-repeat;
                    background-size: 100% 100%;
                    &:hover{
                        .icon_syschat_on
                    }
                }

                &>a,
                .uploadbox {
                    display: inline-block;
                    width: 18px;
                    height: 18px;
                    margin: 10px 0 10px 20px;
                    vertical-align: middle;
                    color: #93999F;
                    font-size: 18px;
                    &.active,&:hover {
                        color: #0077AA;
                    }
                }

                .uploadbox a {
                    color: #93999F;
                }
                .expressionlist {
                    position: absolute;
                    bottom: 30px;
                    background: #fff;
                    padding: 10px;
                    height: 180px;

                    li {
                        width: 20px;
                        height: 20px;
                        margin: 8px;
                        float: left;

                        a {
                            width: 24px;
                            height: 20px;
                            background: url(/static/img/qqface.png) -4px -4px no-repeat;
                        }

                        img {
                            width: 24px;
                            height: 24px;
                        }

                        /* 表情*/
                        .intro-loop(105);

                        .intro-loop(@n, @i: 1) when (@i <=@n) {
                            .intro-@{i} {
                                background-position: -4px + -29px * mod(@i , 15) -4px + -29px *floor(@i / 15);
                            }

                            .intro-loop(@n, (@i + 1))
                        }

                        .intromoji-loop(284);

                        .intromoji-loop(@n, @i: 105) when (@i <=@n ) {
                            .intromoji-@{i} {
                                background: url(/static/img/emoji.png) no-repeat;
                                background-size: 434px auto;
                                background-position: 1px+ -29px * mod(@i , 15) 202px + -29px *floor(@i / 15);
                            }

                            .intromoji-loop(@n, (@i + 1))
                        }

                    }
                }
            }

            .chatinput {
                outline: none;
                padding: 10px;
                width: calc(100% - 20px);
                height: calc(100% - 56px);
                background: transparent;
                border: none;
                resize: none;

            }

            /* 发送按钮 */
            .btn_send {
                width: 76px;
                height: 32px;
                background: rgba(0, 153, 255, 1);
                border-radius: 2px;
                display: block;
                position: absolute;
                bottom: 30px;
                right: 20px;
                text-align: center;
                line-height: 32px;
                color: #fff;
            }
        }

        .gray_bg {
            background: #999;
        }

        /* 修改备注弹窗 */

        .remarkbox {
            box-shadow: 0px 0px 18px 0px rgba(5, 2, 2, 0.28);
            border-radius: 6px;

            .remarktop {
                text-align: center;
                padding: 10px 8px 0;
                position: relative;

                &>img{
                    width: 15px;
                    height: 14px;
                    position: absolute;
                    top: -14px;
                    right: -15px;
                    cursor: pointer;
                }
                .imgbox {
                    height: 60px;
                    width: 60px;
                    margin: 0 auto 14px;

                    img {
                        height: 60px;
                        width: 60px;
                        border-radius: 50%;
                    }
                }

                .name {
                    font-size: 18px;
                    line-height: 22px;
                    margin-top: 6px;
                    color: #2A2A2A;
                }

                .wxname {
                    font-size: 12px;
                    line-height: 18px;
                    margin-top: 6px;
                    color: #93999F;
                }
            }

            .remarkbot {
                margin-top: 18px;
                border-top: 1px solid rgba(226, 231, 235, 1);
                padding-top: 24px;
                line-height: 32px;
                font-size: 14px;

                &>span{
                    display: inline-block;
                    width: 56px;
                }

                &.tipsbot {
                    line-height: 20px;
                    font-size: 14px;
                    border: none;
                    margin-top: 0;
                    padding-top: 4px;

                    .edittipsbox {
                        height: 80px;
                        width: 100%;

                        li {
                            float: left;
                            height: 32px;
                            line-height: 32px;
                            margin-right: 8px;
                            margin-bottom: 12px;
                            padding: 0 8px;
                            background: rgba(218, 222, 224, 0.06);
                            border-radius: 2px;
                            border: 1px solid rgba(218, 222, 224, 0.6);
                            cursor: pointer;

                            &.active{
                                background:rgba(236,245,255,1);
                                border:1px solid rgba(224,237,255,1);
                                color: #0099FF;
                            }
                        }
                    }
                }

                &>span {
                    color: #93999F;
                    vertical-align: top;
                }

                .editnickname {
                    display: inline-block;
                    height: 28px;
                    margin-left: 20px;
                    width: 185px;

                    input {
                        width: 106px;
                        height: 28px;
                        padding: 0 10px;
                        border: 1px solid #0099FF;
                        border-radius: 2px;
                    }

                    i {
                        cursor: pointer;
                        display: inline-block;
                        width: 15px;
                        height: 15px;
                        background: url(/static/img/choose.png) center no-repeat;
                        vertical-align: middle;
                    }

                    a {
                        display: inline-block;
                        height: 30px;
                        line-height: 30px;
                        margin-left: 5px;
                        color: #fff;
                        padding: 0 10px;
                        border-radius: 4px;
                        background: rgba(0, 153, 255, 1);
                    }
                }
            }


        }

    }

    // 微信语音
    .wifi-symbol {
        width: 50px;
        height: 50px;
        box-sizing: border-box;
        overflow: hidden;
        position: absolute;
        top: -5px;
    }

    .playaudio .second {
        animation: fadeInOut 1s infinite 0.2s;
    }

    .playaudio .third {
        animation: fadeInOut 1s infinite 0.4s;
    }

    .wifi-circle {
        border: 5px solid #999999;
        border-radius: 50%;
        position: absolute;
    }

    .first {
        width: 5px;
        height: 5px;
        background: #cccccc;
        top: 45px;
        left: 45px;
    }

    .second {
        width: 20px;
        height: 20px;
        top: 35px;
        left: 35px;
    }

    .third {
        width: 30px;
        height: 30px;
        top: 25px;
        left: 25px;

    }

    @keyframes fadeInOut {
        0% {
            opacity: 0;
            /*初始状态 透明度为0*/
        }

        100% {
            opacity: 1;
            /*结尾状态 透明度为1*/
        }
    }

</style>
<style>
    .el-dialog {
        border-radius: 6px;
    }

    .remarkbox .el-dialog__body {
        padding: 30px!important;
    }

    .remarkbox .el-dialog__header {
        display: none;
    }

    .remarkbox .el-dialog__footer {
        padding: 0 30px 20px 30px!important;
    }

    .loading .el-loading-spinner .path {
        stroke: #c0c4cc
    }

    .el-image-viewer__wrapper {
        top: 60px;
    }

    .el-icon-circle-close,
    .el-icon-download {
        color: #fff;
    }

    .el-image {
        vertical-align: top;
    }

    .el-upload {
        width: 100%;
    }

    .el-upload-dragger {
        height: 144px;
        width: 100%;
    }

    .uploadbox .el-icon-upload {
        margin-top: 25px;
    }

    .showfilelist .el-upload {
        display: none;
    }

    .el-upload-list {
        display: block;
        height: 134px;
        background: #F8F9FA;
        position: absolute;
        top: 36px;
        left: 0;
        width: 375px;
    }

</style>



// WEBPACK FOOTER //
// src/views/customerservice/components/chat.vue